"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const initializeStickies = (selectedToolType, stickies, tools) => {
    if (!Array.isArray(stickies)) {
        return;
    }
    let newSticky;
    let defaultY = 100;
    let defaultX = 200 +
        (document.body.offsetWidth - (document.body.offsetHeight / 3) * 4) / 2;
    const offsetX = 30;
    const offsetY = 30;
    if (stickies.length > 0) {
        const lastSticky = stickies[stickies.length - 1];
        defaultX = lastSticky.stickyRect.x + offsetX;
        defaultY = lastSticky.stickyRect.y + offsetY;
    }
    switch (selectedToolType) {
        case bridge_schema_1.ToolType.StickyHandWriting:
            newSticky = [
                {
                    identifier: Math.round(Math.random() * 10e6).toString(), //NOSONAR
                    stickyRect: { x: defaultX, y: defaultY, width: 250, height: 280 },
                    text: undefined,
                    curves: [],
                    type: bridge_schema_1.ToolType.StickyHandWriting,
                },
            ];
            break;
        case bridge_schema_1.ToolType.StickyText:
        default:
            newSticky = [
                {
                    identifier: Math.round(Math.random() * 10e6).toString(), //NOSONAR
                    stickyRect: { x: defaultX, y: defaultY, width: 250, height: 280 },
                    text: '',
                    type: bridge_schema_1.ToolType.StickyText,
                },
            ];
            break;
    }
    tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().addSticky(newSticky);
};
exports.default = initializeStickies;
// const stickyExists = stickies?.some(sticky =>
//   newSticky?.some(
//     newStickyItem => newStickyItem.identifier === sticky.identifier
//   )
// );
